import {
  REQUEST_REGISTER,
  REGISTER_SUCCESS,
  LOGOUT,
  UPDATE_LOCAL_USER_PATIENT,
  ADD_USER_APPOINTMENT
} from '../actions/authentication';
import { User } from '../../models';
import deepSet from '../../utils/deepSet';

export type UserState = {
  user: User | null;
  accessToken: string | null;
  isRopc: boolean;
};

export interface AuthenticationRootState extends UserState {
  expirationDate: Date | null;
  isLoading: Boolean;
}

const baseState = {
  isLoading: false,
  user: null,
  accessToken: null,
  expirationDate: null,
  isRopc: false
};

function authentication(
  state: AuthenticationRootState = baseState,
  action: any
) {
  switch (action.type) {
    case REQUEST_REGISTER:
      return Object.assign({}, state, {
        isLoading: true,
        user: action.user,
        accessToken: action.accessToken,
        expirationDate: action.expirationDate,
        isRopc: action.isRopc
      });

    case REGISTER_SUCCESS:
      const expirationDate = new Date();
      expirationDate.setHours(new Date().getHours() + 1);
      return Object.assign({}, state, {
        isLoading: false,
        user: action.user,
        accessToken: action.accessToken,
        expirationDate,
        isRopc: action.isRopc
      });

    case UPDATE_LOCAL_USER_PATIENT:
      if (state.user) {
        let newPatient = state.user.patient.copyWith({});

        for (let [key, value] of Object.entries(
          action.patientAttributesToUpdate
        )) {
          deepSet(newPatient, key, value);
        }
        if (action.patientAttributesToUpdate.mutual) {
          newPatient.documents.mutual = action.patientAttributesToUpdate.mutual;
        }
        if (action.patientAttributesToUpdate.insurance) {
          newPatient.documents.insurance =
            action.patientAttributesToUpdate.insurance;
        }
        return Object.assign({}, state, {
          user: state.user.copyWith({
            patient: newPatient
          })
        });
      }
      break;

    case ADD_USER_APPOINTMENT:
      if (state.user) {
        return Object.assign({}, state, {
          user: state.user.copyWith({
            patient: state.user.patient.copyWith({
              appointments: [
                ...state.user.patient.appointments,
                action.appointment
              ]
            })
          })
        });
      }
      break;

    case LOGOUT:
      return Object.assign({}, baseState);

    default:
      return state;
  }
}

export default authentication;
